import { createStyles } from '@mui/styles';
import { APTheme } from './../../../../core/TenantProvider/tenants';

import CommonStyles from './Common.style';

export default (theme: APTheme) => createStyles({
  ...CommonStyles(theme),
  panelContainer: {
    '& .policyContainer': {
      height: 165,
      padding: 25,
      overflowY: 'auto',
      background: '#f5f5f5',
      boxSizing: 'border-box',
      marginTop: 15,
      '& > ul': {
        padding: '0 0 0 15px',
        margin: '0 0 1.875rem 0',
        listStyle: 'disc',
        boxSizing: 'border-box',
      },
      '& li,& p': {
        lineHeight: '1.4',
        fontSize: 14
      },
      '& li': {
        lineHeight: '1.4',
        padding: 0,
        margin: '0 0 10px 0',
        '& > ul': {
          padding: '15px 0 0 20px',
        },
      },
      '& a': {
        color: '#2d91e9'
      }
    }
  },
  summaryEditBtn: {
    background: 'none',
    padding: 0,
    border: 'none',
    height: 'auto',
    minWidth: 'auto',
    outline: 'none',
    color: '#2d91e9',
    '& .MuiTouchRipple-root': {
      display: 'none'
    },
    '&:hover': {
      background: 'none'
    }
  },
  checkboxLink: {
    color: '#2d91e9'
  },
  checkboxBoldText: {
    fontWeight: 700
  },
  policyContainerLabel: {
    fontWeight: 500,
    paddingLeft: 30
  },
  panelInlineError: {
    color: '#f44336',
    display: 'block',
    fontSize: 12,
    fontWeight: 500,
    marginBottom: 5,
  },
  linkButton : {
    color:  '#2D91E9',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '23px',
    letterSpacing: '-0.5px',
    marginTop : 8
  },
  referenceDetails : {
    color:  '#161616',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.8px',
    marginTop : 8
  },
  stateOfUSADisclaimerWrapper: {
    marginTop: '25px',
    "& >.innerWrapper": {
      padding: '10px',
      backgroundColor: '#f5f5f5',
      boxShadow: 'none',
      "& >.MuiCollapse-container": {
        margin: '0px',
        "& >.MuiCollapse-wrapper": {
          "& >.MuiCollapse-wrapperInner": {
            "& >.MuiAlert-outlinedInfo": {
              "& >.MuiAlert-message": {
                color: '#4A4A4A',
                fontSize: '16px'
              }
            }
          }
        }
      }
    }
  }
});
